module.exports = " <div class=auth _v-5de173f3=\"\"> <tab-bar _v-5de173f3=\"\"></tab-bar> <div class=body _v-5de173f3=\"\"> <router-view _v-5de173f3=\"\"></router-view> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-5de173f3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Auth.vue
 ** module id = 350
 ** module chunks = 2
 **/